import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgGroup = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.833 3.333v8a.5.5 0 0 1-.5.5H1.667a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h3.36a.5.5 0 0 1 .354.146l.354-.353-.354.353 1.414 1.415a1.5 1.5 0 0 0 1.061.439h6.477a.5.5 0 0 1 .5.5Z"
      fill="#C4C4C4"
      fillOpacity={0.1}
      stroke="#919499"
    />
  </svg>
);
const Memo = memo(SvgGroup);
export default Memo;
